import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";
import { prefetchRisksGridViewAndForm, risksGridPageRoutes } from "./RisksGridPage";

export const route: NavigationItemType["route"] = { path: "risks", children: risksGridPageRoutes };
export const to = (paths: Paths) => paths.risksGrid();
export const prefetch = prefetchRisksGridViewAndForm;
